import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllDiarioObrasEfetivoUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_efetivo_use_case";
import { DiarioObrasEfetivoFilter } from "../../models/diario_obras_efetivo_filter";
import { DiarioObrasEfetivoLista } from "../../models/diario_obras_efetivo_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";


// GetAllDiarioObrasEfetivoServicoUseCase


export class GetAllDiarioObrasEfetivoServicoUseCase
  extends BasePaginatedUseCase<DiarioObrasEfetivoLista>
  implements IGetAllDiarioObrasEfetivoUseCase {
  private _totalGeral: number = 0;
  private _totalPropria: number = 0;
  private _totalTerceirizada: number = 0;
  
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }
  get totalGeral(): number {
    return this._totalGeral;
  }
  get totalPropria(): number {
    return this._totalPropria;
  }
  get totalTerceirizada(): number {
    return this._totalTerceirizada;
  }

  async getAllListagemDiariosObrasEfetivo(
    filter: DiarioObrasEfetivoFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdDiarioObras === undefined) throw new Error('Id de diario de obra inválido!');

    const response = await this.repository
      .getAllListagemDiariosObrasEfetivo(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    
    const rawResponse = response as any;
    
    this._totalGeral = rawResponse.totalGeral ?? 0;
    this._totalPropria = rawResponse.totalPropria ?? 0;
    this._totalTerceirizada = rawResponse.totalTerceirizada ?? 0;
  }
}
